import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { get } from "http";
import _ from "lodash";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import URLNodeCondition from "../SidePanel/Inspector/components/URLNodeCondition/URLNodeCondition";
import NodePanel from "./NodePanel";

const URLNode = {
  Type: "url",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: URLNode.Type,
      showTyping: false,
      delay: 0,
      conditions: [{ id: RandomId(6), type: "path", value: "/home", goto: null }],
      elseGoto: null
    };

    return node; //
  },
  PlumbData: function (node: NodeInterface) {
    var tabs: any = [];

    for (var i = 0; i < node.conditions.length; i++) {
      var condition = node.conditions[i];
      const title = condition.value;
      // if (condition.type == "host") {
      //   title = "HOST == " + condition.value;
      // }
      // if (condition.type == "path") {
      //   title = "PATH == " + condition.value;
      // }
      tabs.push({
        id: "conditions_" + condition.id,
        source: "conditions_" + i + "_goto",
        target: condition.goto,
        title: title
      });
    }
    tabs.push({
      id: "elseGoto",
      source: "elseGoto",
      target: node.elseGoto,
      title: "ELSE"
    });
    return TabNodeLayoutData({
      node: node,
      title: "URL",
      baseWidth: 150,
      tabs: tabs
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    //
    constructor(props: any) {
      super(props);

      this.addCondition = this.addCondition.bind(this);
    }

    addCondition() {
      let conditionData = {
        id: RandomId(6),
        type: "path",
        value: "/home",
        goto: null
      };
      let node = JSON.parse(JSON.stringify(this.props.node));
      let arr = _.get(node, "conditions");
      if (!arr) {
        arr = [];
      }
      arr.push(conditionData);
      _.set(node, "conditions", arr);
      this.props.updateNode(node, this.props.node, true);
    }

    render() {
      var self = this;

      const conditions = this.props.node.conditions.map(function (item: any, index: any) {
        return (
          <URLNodeCondition
            key={item.id}
            condition={item}
            name={"conditions." + index + ".value"}
            onChange={self.onChange}
            arrayName="conditions"
            arrayIndex={index}
            delete={self.deleteValue}
          />
        );
      });

      return (
        <div>
          <div className="panel dayOfWeek_panel" style={{ paddingBottom: "300px" }}>
            <InspectorNodeHeader title="URL" />
            <div className="panelRow">
              {conditions}
              <div className="addElementButton" onClick={this.addCondition}>
                + ADD CONDITION
              </div>
            </div>
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default URLNode;
